





import Button from "@/components/parts/competences/card/components/btn/Button.vue";
export default {
  name: "ExtraButton",
  components: { Button }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/parts/extra_buttons/ExtraButton.vue